<app-layout class="home-design" [enableTopGap]="true">
  <app-home-hero></app-home-hero>
  <app-home-about></app-home-about>
  <app-home-band-road></app-home-band-road>
  <app-home-packages></app-home-packages>
  <app-home-band-lane></app-home-band-lane>
  <app-home-features></app-home-features>
  <app-home-band-night></app-home-band-night>
  <app-home-contact></app-home-contact>
</app-layout>
